import React, { FC, ReactNode } from 'react';

import { EXTERNAL_PATHS } from 'src/common/constants';
import getClassName from 'src/common/utils/getClassName';
import ExternalLink from '../../../common/components/ExternalLink';
import s from './PayoutLink.module.scss';

type PayoutLinkProps = {
  children: ReactNode;
  classNameModifier?: string;
};

const PayoutLink: FC<PayoutLinkProps> = ({
  children,
  classNameModifier,
}) => (
  <ExternalLink
    to={EXTERNAL_PATHS.ADMIN_PAYMENTS}
    className={getClassName(s, 'root', classNameModifier)}
  >
    {children}
  </ExternalLink>
);

export default PayoutLink;
